import { IAPIRoutes } from "../../../../config";

export const IPVRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getIPVNotesList: IGetIPVNotesListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetIPVNotesList
        .replace("{clinic_id}", payload.clinic_id?.toString())
        .replace("{status}", payload.status?.toString()),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const addIPVNotesAck: IAddIPVNotesAckAPI = async ({
    clinic_id,
    ...payload
  }) => {
    return POST(
      APIRoutes.apiAddIPVNotesAck
        .replace("{clinic_id}", clinic_id.toString())
        .replace("{note_id}", payload.note_id.toString()),
      { ...payload },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };
  return {
    getIPVNotesList,
    addIPVNotesAck,
  };
};
